{
  "_format": "hh-sol-artifact-1",
  "contractName": "LoanLib",
  "sourceName": "contracts/libraries/LoanLib.sol",
  "abi": [
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "asset",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "LoanFunded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "pool",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "liquidityAsset",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "LoanPaymentMade",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "asset",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "fundingVault",
          "type": "address"
        }
      ],
      "name": "LoanPrincipalPaid",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "RAY",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "principal",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "indicativeApr",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "finalizedApr",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "durationDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dropDeadTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "originationBps",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "accrualStartDayTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferInWindowDurationDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutWindowDurationDays",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "priorLoan",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "startingPrincipal",
              "type": "uint256"
            }
          ],
          "internalType": "struct ILoanSettings",
          "name": "settings",
          "type": "tuple"
        },
        {
          "internalType": "uint256",
          "name": "scalingValue",
          "type": "uint256"
        }
      ],
      "name": "previewOriginationFee",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "version",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "0x73000000000000000000000000000000000000000030146080604052600436106100565760003560e01c806354fd4d501461005b578063552033c4146100705780635745e3f1146100905780637b67dc51146100a3575b600080fd5b60405161010081526020015b60405180910390f35b610082676765c793fa10079d601b1b81565b604051908152602001610067565b61008261009e366004610472565b6100d0565b8180156100af57600080fd5b506100c36100be3660046104bc565b610122565b60405161006791906104fd565b60006101196127106100fa676765c793fa10079d601b1b816101006101688260608b01358a61018b565b90610197565b6101136101408a013560a08b013561018b565b9061018b565b90505b92915050565b6000811561013f5761013f6001600160a01b0385163385856101a3565b604080516001600160a01b0386168152602081018490527f726d5f1a838fe31748f737fa3ae5539ccff95952adfc593a1299532b643ff7a8910160405180910390a15060029392505050565b60006101198284610525565b6000610119828461054a565b604080516001600160a01b0385811660248301528416604482015260648082018490528251808303909101815260849091019091526020810180516001600160e01b03166323b872dd60e01b1790526101fd908590610203565b50505050565b6000610258826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166102e29092919063ffffffff16565b9050805160001480610279575080806020019051810190610279919061056c565b6102dd5760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b60648201526084015b60405180910390fd5b505050565b60606102f184846000856102f9565b949350505050565b60608247101561035a5760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f6044820152651c8818d85b1b60d21b60648201526084016102d4565b600080866001600160a01b0316858760405161037691906105b9565b60006040518083038185875af1925050503d80600081146103b3576040519150601f19603f3d011682016040523d82523d6000602084013e6103b8565b606091505b50915091506103c9878383876103d4565b979650505050505050565b6060831561044357825160000361043c576001600160a01b0385163b61043c5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e747261637400000060448201526064016102d4565b50816102f1565b6102f183838151156104585781518083602001fd5b8060405162461bcd60e51b81526004016102d491906105d5565b60008082840361018081121561048757600080fd5b6101608082121561049757600080fd5b9395938601359450505050565b6001600160a01b03811681146104b957600080fd5b50565b6000806000606084860312156104d157600080fd5b83356104dc816104a4565b925060208401356104ec816104a4565b929592945050506040919091013590565b602081016006831061051f57634e487b7160e01b600052602160045260246000fd5b91905290565b808202811582820484141761011c57634e487b7160e01b600052601160045260246000fd5b60008261056757634e487b7160e01b600052601260045260246000fd5b500490565b60006020828403121561057e57600080fd5b8151801515811461058e57600080fd5b9392505050565b60005b838110156105b0578181015183820152602001610598565b50506000910152565b600082516105cb818460208701610595565b9190910192915050565b60208152600082518060208401526105f4816040850160208701610595565b601f01601f1916919091016040019291505056fea2646970667358221220dff7f2f948d4c595761bf7bc178be64c67c304e33e47be8e25def95d21dcd8e764736f6c63430008130033",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
